import './MobileToggleBar.scss';

import classnames from 'classnames';
import { array, bool, func, number, oneOfType, string } from 'prop-types';
import React from 'react';

const MobileToggleBar = ({ className, onClick, options, selection }) => (
  <div className={`mobile-toggle-bar ${className}`}>
    {options.map((option, idx) => {
      const className = classnames('mobile-option', {
        selected: option.value === selection
      });
      return (
        <div
          className={className}
          key={idx}
          onClick={() => onClick(option.value)}>
          {option.label}
        </div>
      );
    })}
  </div>
);

MobileToggleBar.propTypes = {
  className: string,
  onClick: func.isRequired,
  options: array.isRequired,
  selection: oneOfType([bool, number, string]).isRequired
};

MobileToggleBar.defaultProps = {
  className: ''
};

export default MobileToggleBar;
